import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as player from '../player.js';
import * as audio from '../audio.js';
import { createPanner } from '../audio/panner.js';
import * as triangle from '../triangle.js';

export {
    init,
}

let mosquito;
let moskitoPanner;

const POIs = [
    {
        name: 'swamp',
        position: { x: 24, y: 4, z: 0 },
        image: 'swamp',
        symbolic: false,
        sound: {
            name: 'swamp',
            gain: 0,
        },
        collision: {
            radius: 2.4,
        },
        async onEnter() {
            moskitoPanner.positionPanner(this.position.x, this.position.z, this.position.y); // TODO: just pass pos !

            mosquito = await audio.buffers.play('mosquito', {
                loop: true,
                gain: 0,
                destination: moskitoPanner,
            });

            // TODO: make the mosquito spin around
            player.config.maxVelocity = 1.4;

            triangle.drop('stonehenge-triangle-3', this.position, {
                collisionRadius: 0.5,
                delay: 5,
            });
        },
        onLeave() {
            mosquito.fade(2, -90, true);
            player.config.maxVelocity = 2.5;
        },
        onStart() {
            audio.panner.play(this);
        }
    },
];

const sounds = [
    { name: 'mosquito', url: new URL('../../sound/Moskito.wav', import.meta.url) },
    { name: 'swamp', url: new URL('../../sound/Marais.wav', import.meta.url) },
];

const images = [
    { name:'swamp', url: new URL('../../images/swamp.png', import.meta.url), ppm: 25 },
];

function init() {
    scene.addPOIs(POIs);
    loader.addImages(images);
    loader.addSounds(sounds);
    moskitoPanner = createPanner();
};